<template>
  <div class="main">
    <report-top></report-top>
    <div id="formTable">
      <div id="text">作业线路列表</div>
      <div id="ddas">
        <!-- <Button @click="reOpenWin" type="primary" size="small" icon="md-cloud-download">导出</Button>-->
        <Button @click="openAdd" type="primary" icon="md-add" size="small"
          >新增</Button
        >
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="carClass">
        <!-- <clzypb :classes="row.scheduleList"></clzypb> -->
        <ul>
          <li
            style="margin-bottom: 10px"
            v-for="(x, index) in row.scheduleList"
            :key="index"
          >
            <b>{{ x.carClasses[0].carNo }} </b>
            <div style="margin-bottom:6px;" v-for="(y, index1) in x.carClasses[0].classesList" :key="index1">
              {{ y.name }}
              <span
                v-for="(t, index2) in y.timeList"
                :key="index2"
                style="margin-right:10px;"
                >{{ t.startTime }} - {{ t.endTime }}</span
              >
              <p>司机：{{ y.driver }}，跟车：{{ y.follower }}</p> 
            </div>
          </li>
        </ul>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="openForm"
      :title="isAdd ? '新增作业线路' : '编辑作业线路'"
      footer-hide
      fullscreen
      @on-cancel="cliclCancelBtn"
    >
      <div style="width: 100%; height: 100%; display: flex">
        <div style="width: calc(100% - 730px); height: 100%">
          <xianlu ref="xianlu" v-if="openForm" :lines="linesData"></xianlu>
        </div>
        <div style="width: 730px; height: 100%">
          <div id="dsaecwewe">
            <Row>
              <Col span="24">
                <Form
                  ref="item"
                  :model="item"
                  :rules="ruleValidate"
                  :label-width="80"
                >
                  <Row :gutter="16">
                    <Col span="8">
                      <FormItem label="线路名称" prop="name">
                        <Input v-model="item.name" placeholder="请输入"></Input>
                      </FormItem>
                    </Col>
                    <Col span="8">
                      <FormItem label="单位名称" prop="groupId">
                        <selectItems
                          :name="item.groupName"
                          @update:name="item.groupName = $event"
                          :id="item.groupId"
                          @update:id="item.groupId = $event"
                        ></selectItems>
                      </FormItem>
                    </Col>
                    <Col span="8">
                      <FormItem label="所属项目" prop="deptName">
                        <selectGroup
                          :name="item.deptName"
                          @update:name="item.deptName = $event"
                          :id="item.deptId"
                          @update:id="item.deptId = $event"
                        >
                        </selectGroup>
                      </FormItem>
                    </Col>
                    <Col span="8">
                      <FormItem label="巡查路线" prop="collectLineId">
                        <selectLine
                          :id="item.collectLineId"
                          @update:id="item.collectLineId = $event"
                          @on-select="selectLine"
                        >
                        </selectLine>
                      </FormItem>
                    </Col>
                    
                    <Col span="8">
                      <FormItem label="作业半径" prop="radius">
                        <Input
                          v-model="item.radius"
                          placeholder="请输入"
                        ></Input>
                      </FormItem>
                    </Col>
                  </Row>
                </Form>
              </Col>
              <Col span="24">
                <paibanTool
                  ref="paibanTool"
                  @close="
                    openForm = false;
                    getList();
                  "
                ></paibanTool>
              </Col>
            </Row>
            <div class="clearfloat">
              <div style="float: right">
                <Button>重置表单</Button>
                <Button type="primary" @click="addUpdate('item')"
                  >提交表单</Button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
import xianlu from "../map/lyMap.vue";
import paibanTool from "./paibanTool.vue";
import clzypb from "./clzypb.vue";
export default {
  components: { xianlu, paibanTool, clzypb },
  data() {
    return {
      openForm: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "线路名称",
          key: "name",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "车辆排班",
          slot: "carClass",
          minWidth: 250,
          maxWidth: 300,
        },
        {
          title: "单位名称",
          key: "groupName",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "所属项目",
          key: "deptName",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "创建者账号",
          key: "createAccount",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        groupId: "",
        deptId: "",
        deptName: "",
        gridId: "",
        name: "",
        startP: "",
        startPId: "",
        endP: "",
        endPId: "",
        //tripNum: 1,
        //tripOne: 1,
        //grade: "一级",
        //roadType: "单向车道",
        radius: 10,
        //length: 0,
        remark: null,
        //pointList: [],
        pointType: 2,
        ruleLineIdList: [],
        collectLineId: "",
      },
      ruleValidate: {
        name: { required: true, message: "必填" },
        groupId: { required: true, message: "必填" },
        deptName: { required: true, message: "必填" },
        tripNum: { required: true, message: "必填" },
        tripOne: { required: true, message: "必填" },
        startP: { required: false, message: "必填" },
        endP: { required: false, message: "必填" },
        radius: { required: true, message: "必填" },
        collectLineId: { required: true, message: "必填" },
        gridId: { required: true, message: "必填" },
      },
      pageNumber: 1,
      pageSize: 50,
      total: 0,
      bucketList: [],
      lines: [],
      linesData: [],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.gc + "/line/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        console.log(res);
        this.tableData = data;
      });
    },
    addUpdate(name) {
      this.$refs[name].validate((valid) => {
        var ddd = this.$refs.paibanTool.watchClass();
        if (!ddd) {
          this.$Message.error("排班信息未填写");
          return;
        }
        this.item.ruleLineIdList = [this.item.collectLineId];
        console.log(this.item);
        if (valid) {
          if (this.isAdd) {
            axios({
              method: "post",
              url: axios.gc + "/line/add",
              data: this.item,
            }).then((res) => {
              if (res) {
                var lineId = res.data.data;
                console.log(lineId);
                this.item.lineId = lineId;
                this.$refs.paibanTool.reData(this.item);
              }
            });
          } else {
            axios({
              method: "post",
              url: axios.gc + "/line/update",
              data: this.item,
            }).then((res) => {
              if (res) {
                console.log(res);
                var lineId = res.data.data;
                this.item.lineId = lineId;
                this.$refs.paibanTool.reData(this.item);
              }
            });
          }
        }
      });
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.gc + "/line/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.openForm = true;
      this.isAdd = false;
      this.item = row;
      this.$refs.paibanTool.getList(this.item.id);
      this.getLinesDetail(row.collectLineId);
      this.getLjtList(row.collectLineId);
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
      this.$refs.xianlu.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    changePage(x) {
      this.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.pageSize = x;
      this.getList();
    },
    selectLine(v) {
      this.getLinesDetail(v.value);
      this.getLjtList(v.value);
    },
    getLinesDetail(v) {
      axios({
        method: "post",
        url: axios.rule + "/route/item",
        data: { id: v },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var abc = res.data.data;
        this.$refs.xianlu.showLine([abc]);
        
      });
    },
    //获取垃圾桶列表
    getLjtList(id) {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.gc + "/siteCollect/list",
        data: {routeId:id},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.$refs.xianlu.showLjt(data);
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style>
#dsaecwewe {
  width: 100%;
  background: #fff;
  padding: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/garbage/zyxl.vue